import { createAction, props } from '@ngrx/store'
import { CurrentFeatureInfoInterface } from '../interfaces/current-feature-info.interface'
import { Feature, Object } from 'ol'
import { DrawInfoboxDrawingStateEnum } from '../../../../../features/map/info-box/parcel-to-group-content/parcel-to-group-shape-draw/draw-infobox-drawing-state.enum'
import { SplitBoxStateEnum } from '../../../../../features/map/info-box/parcel-to-group-content/parcel-to-group-split/split-box-state.enum'
import { IGeneralMapZoomedId } from './general-map.reducer'
import { MapInfoBoxTypeEnum } from '../../../../../features/map/info-box/map-info-box-type.enum'

export const SOURCE = '[General Map]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const initMap = createAction(
    `${SOURCE} InitMap`, props<{ mapId: string}>()
)
// ==> setMap
// export const beforeSetMap = createAction( // used by effects
//     `${SOURCE} BeforeSetMap`, props<{ mapId: string; layersConfig: any; mapOptions: any}>() // @TODO create interfaces for layersConfig and mapOptions
// )
// export const setMap = createAction(
//     `${SOURCE} SetMap`, props<{ mapId: string; map: any; layersConfig?: any; mapOptions?: any}>()
// )
// ==>
export const resetMap = createAction(
    `${SOURCE} ResetMap`, props<{ mapId: string}>()
)

export const setBacklink = createAction(
    `${SOURCE} SetBacklink`, props<{ mapId: string; backlink: boolean}>()
)

export const setMapSimplePagePrintHeading = createAction(
    `${SOURCE} SetMapSimplePagePrintHeading`, props<{ mapId: string; heading: string}>()
)

export const setMapSimpleCurrentFeatureInfo = createAction(
    `${SOURCE} SetMapSimpleCurrentFeatureInfo`, props<{ mapId: string; info: CurrentFeatureInfoInterface}>()
)
export const resetMapSimpleCurrentFeatureInfo = createAction(
    `${SOURCE} ResetMapSimpleCurrentFeatureInfo`, props<{ mapId: string}>()
)

export const setMapSimpleDetailFeature = createAction(
    `${SOURCE} SetMapSimpleDetailFeature`, props<{ mapId: string; feature: any}>()
)
export const resetMapSimpleDetailFeature = createAction(
    `${SOURCE} ResetMapSimpleDetailFeature`, props<{ mapId: string}>()
)

export const setMapSimpleFeatures = createAction(
    `${SOURCE} SetMapSimpleFeatures`, props<{ mapId: string; features: any[]}>()
)

export const setHeader = createAction(
    `${SOURCE} SetHeader`, props<{ mapId: string; value: string}>()
)

export const setMapMeasuredLength = createAction(
    `${SOURCE} SetMapSimpleMapMeasuredLength`, props<{ mapId: string; measuredLength: number}>()
)
export const resetMapMeasuredLength = createAction(
    `${SOURCE} ResetMapSimpleMapMeasuredLength`, props<{ mapId: string}>()
)

export const setMapMeasuredArea = createAction(
    `${SOURCE} SetMapSimpleMapMeasuredArea`, props<{ mapId: string; measuredArea: number}>()
)
export const resetMapMeasuredArea = createAction(
    `${SOURCE} ResetMapSimpleMapMeasuredArea`, props<{ mapId: string}>()
)

export const setMapMeasuredCoordinates = createAction(
    `${SOURCE} SetMapSimpleMapMeasuredCoordinates`, props<{ mapId: string; measuredCoordinates: number}>()
)
export const resetMapSimpleMapMeasuredCoordinates = createAction(
    `${SOURCE} ResetMapSimpleMapMeasuredCoordinates`, props<{ mapId: string}>()
)

export const setMapDrawingBoxDrawState = createAction(
    `${SOURCE} SetMapDrawingBoxDrawState`, props<{ mapId: string; drawingState: DrawInfoboxDrawingStateEnum}>()
)
export const resetMapDrawingBoxDrawState = createAction(
    `${SOURCE} ResetMapDrawingBoxDrawState`, props<{ mapId: string}>()
)

export const setMapSplitBoxState = createAction(
    `${SOURCE} SetMapSplitBoxState`, props<{ mapId: string; splitInfoboxState: SplitBoxStateEnum}>()
)

export const setMapDrawingBoxPolygonValid = createAction(
    `${SOURCE} SetMapDrawingBoxPolygonValid`, props<{ mapId: string; value: boolean}>()
)

export const setAllParcelsLayerVisible = createAction(
    `${SOURCE} SetAllParcelsLayerVisible`, props<{ mapId: string; value: boolean}>()
)

export const setMapDrawingBoxDrawCoordinatesLength = createAction(
    `${SOURCE} SetMapDrawingBoxDrawCoordinatesLength`, props<{ mapId: string; value: number}>()
)
export const resetMapDrawingBoxDrawCoordinatesLength = createAction(
    `${SOURCE} ResetMapDrawingBoxDrawCoordinatesLength`, props<{ mapId: string}>()
)

export const resetMapDrawing = createAction(
    `${SOURCE} ResetMapDrawing`, props<{ mapId: string; fullReset: boolean}>()
)
export const resetMapSplitting = createAction(
    `${SOURCE} ResetMapSplitting`, props<{ mapId: string}>()
)

export const setMapSimpleMapParcelListShowAddonInformation = createAction(
    `${SOURCE} SetMapSimpleMapParcelListShowAddonInformation`, props<{ mapId: string; value: boolean}>()
)

export const setLayersConfig = createAction(
    `${SOURCE} SetMapSimpleLayersConfig`, props<{ mapId: string; config: any}>()
)
export const resetMapSimpleLayersConfig = createAction(
    `${SOURCE} ResetMapSimpleLayersConfig`, props<{ mapId: string}>()
)

export const setMapSimpleLayersOutsideSelector = createAction(
    `${SOURCE} SetMapSimpleLayersOutsideSelector`, props<{ mapId: string; selector: any[]}>()
)
export const resetMapSimpleLayersOutsideSelector = createAction(
    `${SOURCE} ResetMapSimpleLayersOutsideSelector`, props<{ mapId: string}>()
)
// ==> padding
export const setPadding = createAction(
    `${SOURCE} SetMapSimplePadding`, props<{ mapId: string; padding: number}>()
)
export const resetMapSimplePadding = createAction(
    `${SOURCE} ResetMapSimplePadding`, props<{ mapId: string}>()
)
// ==>
export const setMapSimpleParcelContractEndingDate = createAction(
    `${SOURCE} SetMapSimpleParcelContractEndingDate`, props<{ mapId: string; date: string}>()
)
export const setMapSimpleParcelContractEndingDateVisible = createAction(
    `${SOURCE} SetMapSimpleParcelContractEndingDateVisible`, props<{ mapId: string; value: boolean}>()
)
export const setMapSimpleParcelContractEndingDateMinimalized = createAction(
    `${SOURCE} SetMapSimpleParcelContractEndingDateMinimalized`, props<{ mapId: string; value: boolean}>()
)
export const setMapSimpleSaveLayersVisibility = createAction(
    `${SOURCE} SetMapSimpleSaveLayersVisibility`, props<{ mapId: string; value: boolean}>()
)
export const setMapSimpleSaveLayersVisibilityAfterInit = createAction(
    `${SOURCE} SetMapSimpleSaveLayersVisibilityAfterInit`, props<{ mapId: string; value: boolean}>()
)
export const enableMapSimpleSaveLayersVisibility = createAction(
    `${SOURCE} EnableMapSimpleSaveLayersVisibility`, props<{ mapId: string}>()
)
export const setMapSimpleStoragePrefix = createAction(
    `${SOURCE} SetMapSimpleStoragePrefix`, props<{ mapId: string; prefix: string}>()
)
// ==> zoomedId
export const setMapSimpleZoomedId = createAction(
    `${SOURCE} SetMapSimpleZoomedId`, props<{ mapId: string; zoomedId: IGeneralMapZoomedId}>()
)
export const resetMapSimpleZoomedId = createAction(
    `${SOURCE} ResetMapSimpleZoomedId`, props<{ mapId: string}>()
)
// ==> setMapInfoBox
export const setMapInfoBox = createAction(
    `${SOURCE} SetMapInfoBox`, props<{ mapId: string; showedInfoBox: MapInfoBoxTypeEnum}>()
)
export const resetMapInfoBox = createAction(
    `${SOURCE} ResetMapInfoBox`, props<{ mapId: string; showedInfoBox: MapInfoBoxTypeEnum}>()
)
// ==>
export const toggleMapInfoBox = createAction(
    `${SOURCE} ToggleMapInfoBox`, props<{ mapId: string; showedInfoBox: MapInfoBoxTypeEnum}>()
)

export const setMapSimpleShowedLpisUserSelectionCollapsed = createAction(
    `${SOURCE} SetMapSimpleShowedLpisUserSelectionCollapsed`, props<{ mapId: string; collapsed: boolean}>()
)

export const setMapSimpleLayersConfigPropertyByLayerId = createAction(
    `${SOURCE} SetMapSimpleLayersConfigPropertyByLayerId`, props<{ mapId: string; layerId: string; property: string; value: any}>()
)

// ==> Effects actions
export const lpisUserSelection = createAction(
    `${SOURCE} LpisUserSelection`, props<{ mapId: string; visible: boolean; lpisConfig: any; doNotUpdateMap: boolean}>()
)
export const setParcelContractEndingDate = createAction(
    `${SOURCE} SetParcelContractEndingDate`, props<{ mapId: string; expDate: string}>()
)
export const setParcelContractEndingDateVisible = createAction(
    `${SOURCE} SetParcelContractEndingDateVisible`, props<{ mapId: string; visible: boolean; isSet: boolean}>()
)
export const createMapSimpleFeatureGroupLayerIfNotExists = createAction(
    `${SOURCE} CreateMapSimpleFeatureGroupLayerIfNotExists`, props<{ mapId: string; layerName: string; zIndex: number}>()
)
export const createFeatureGroupLayerIfNotExistsWithUpdatedFeatureAreas = createAction(
    `${SOURCE} CreateMapSimpleFeatureGroupLayerIfNotExistsWithUpdatedFeatureAreas`, props<{ mapId: string; layerName: string; zIndex: number}>()
)

export const setupLpisDetail = createAction(
    `${SOURCE} SetupLpisDetail`, props<{ mapId: string; feature: Object}>()
)
export const setupParcelDetail = createAction(
    `${SOURCE} SetupParcelDetail`, props<{ mapId: string; feature: Feature; backlink: boolean}>()
)
export const setupParcelList = createAction(
    `${SOURCE} setupParcelList`, props<{ mapId: string}>()
)

export const openInfoBox = createAction(
    `${SOURCE} OpenInfoBox`, props<{ mapId: string; infoBoxType: MapInfoBoxTypeEnum}>()
)
export const closeInfobox = createAction(
    `${SOURCE} CloseInfobox`, props<{ mapId: string; infoBoxType: MapInfoBoxTypeEnum}>()
)

export const updateLayerConfigPropertyByLayerId = createAction(
    `${SOURCE} UpdateLayerConfigPropertyByLayerId`, props<{ mapId: string; layerId: string; property: string; value: any}>()
)

export const switchDefaultLpisLayer = createAction(
    `${SOURCE} SwitchDefaultLpisLayer`, props<{ mapId: string; newConfig: any; hide: boolean}>()
)
export const noAction = createAction(`${SOURCE} NoAction`)
// ==><==
